import { API } from "./apiAuth";
import axios from "axios";

export const API2 = axios.create({
  baseURL: process.env.VUE_APP_API_ALARM,
  headers: {
    Accept: "*/*",
  },
});



// Function to get board languages
const getAvailLanguages = async () => {
  try {
    const response = await API.get("board-languages");
    // response.data = {
    //   "isSuccess": true,
    //   "data": [
    //     {
    //       "language": "kr",
    //       "display": "한국어"
    //     },
    //     {
    //       "language": "en",
    //       "display": "English"
    //     },
    //     {
    //       "language": "jp",
    //       "display": "日本語"
    //     },
    //     {
    //       "language": "cn",
    //       "display": "中文"
    //     },
    //     {
    //       "language": "ru",
    //       "display": "Русский"
    //     },
    //     {
    //       "language": "vn",
    //       "display": "Tiếng Việt"
    //     }
    //   ]
    // }

    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

// Function to get All AM board
const getAllAM = async () => {
  try {
    const response = await API.get(`board-briefings/morning`);
    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

// Function to get All PM board
const getAllPM = async () => {
  try {
    const response = await API.get(`board-briefings/afternoon`);
    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

const getAllPick = async () => {
  try {
    const response = await API.get(`board-briefings/morning`);
    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

// Function to get All notice board
const getAllNotice = async () => {
  try {
    const response = await API.get(`board-notices`);
    return response.data;
  } catch (error) {
    console.error("Error get notice board", error);
    throw error;
  }
};

// Function to get AM board
const getAMBoard = async (language) => {
  try {
    const response = await API.get(`board-briefings/morning/${language}`);
    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

// Function to get PM board
const getPMBoard = async (language) => {
  try {
    const response = await API.get(`board-briefings/afternoon/${language}`);
    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

const getPickBoard = async (language) => {
  try {
    const response = await API.get(`board-briefings/morning/${language}`);
    return response.data;
  } catch (error) {
    console.error("Error get board languages", error);
    throw error;
  }
};

// Function to get notice board
const getNoticeBoard = async (language) => {
  try {
    const response = await API.get(`board-notices/${language}`);
    return response.data;
  } catch (error) {
    console.error("Error get notice board", error);
    throw error;
  }
};

// Function to get AI Brief Title
const getAiBriefTitle = async (limit, timetype, language) => {
  try {
    const response = await API2.get(
      `analysis/gpt-title?limit=${limit}&timetype=${timetype}`
    );
    if (response.status === 200) {
      let data = response.data.result;
      let title = [];
      const languages = ["korea", "japan", "english", "chinese", "vietnam"];

      if (language === "default" || language === "ru") {
        data.forEach((item) => {
          languages.forEach((lang) => {
            title.push({ id: item.id, title: item.title, language: lang });
          });
        });
      } else {
        const langMap = {
          kr: "korea",
          en: "english",
          jp: "japan",
          cn: "chinese",
          vn: "vietnam",
        };
        const titleLang = langMap[language] || language;
        title = data.map((item) => ({ ...item, language: titleLang }));
      }
      return title;
    }
  } catch (error) {
    // console.error("Error get AI Brief", error);
    return;
  }
};

// Function to get AI Brief
const getAiBrief = async (id, language) => {
  try {
    const response = await API2.get(
      `analysis/gpt-languge?id=${id}&language=${language}`
    );
    return response.data;
  } catch (error) {
    if (error.response.status === 422) {
      location.reload = "/board/ai-brief"
    }
    return;
  }
};

export default {
  getAvailLanguages,
  getAllAM,
  getAllPM,
  getAllNotice,
  getAMBoard,
  getPMBoard,
  getPickBoard,
  getAllPick,
  getNoticeBoard,
  getAiBriefTitle,
  getAiBrief,
};
